import { render, staticRenderFns } from "./SpecialDataMainPage.vue?vue&type=template&id=4570b0f8&scoped=true&"
import script from "./SpecialDataMainPage.vue?vue&type=script&lang=js&"
export * from "./SpecialDataMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570b0f8",
  null
  
)

export default component.exports